import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const DeleteAccountModal = ({ isOpen, onClose, onConfirm, account, loading }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-16">
      <div className="absolute inset-0 bg-black/50" onClick={onClose}></div>
      <div className="relative bg-card rounded-lg shadow-elevation-3 w-full max-w-md p-24 md:p-32">
        <div className="flex items-center justify-center w-16 h-16 bg-error/10 rounded-full mx-auto mb-16">
          <Icon name="AlertTriangle" size={32} color="var(--color-error)" />
        </div>
        
        <h2 className="text-xl md:text-2xl font-heading font-bold text-card-foreground text-center mb-12">
          Delete Account?
        </h2>
        
        <p className="text-sm md:text-base text-muted-foreground text-center mb-16">
          Are you sure you want to delete <span className="font-semibold text-card-foreground">{account?.name}</span>?
        </p>
        
        <div className="bg-error/5 border border-error/20 rounded-lg p-12 mb-24">
          <p className="text-sm text-error flex items-start gap-8">
            <Icon name="AlertCircle" size={16} color="currentColor" className="flex-shrink-0 mt-2" />
            <span>This action cannot be undone. All transactions associated with this account will also be deleted.</span>
          </p>
        </div>
        
        <div className="flex gap-12">
          <Button
            variant="outline"
            size="md"
            fullWidth
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            variant="default"
            size="md"
            fullWidth
            onClick={onConfirm}
            disabled={loading}
            className="bg-error hover:bg-error/90 text-white"
          >
            {loading ? 'Deleting...' : 'Delete Account'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccountModal;